export default __webpack_public_path__ + "static/media/3b99646e716563ad9825c3c881091887.svg";